import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { BenchmarkMetricCard } from "./benchmark-metric-card";
import { MetricCard } from "./metric-card";
import type { BaseMetricCardProps, BenchmarkMetricCardProps } from "./types";

interface DraggableCardProps<T = Record<string, unknown>>
  extends BenchmarkMetricCardProps<T> {
  showBenchmark?: boolean;
}

export function DraggableCard<T = Record<string, unknown>>({
  id,
  title,
  value,
  isLoading,
  onDrilldown,
  isWip,
  tooltip,
  category,
  benchmarkValue,
  benchmarkLoading,
  showBenchmark = false,
  metrics,
}: DraggableCardProps<T>) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    animateLayoutChanges: () => false,
  });

  // Simplified transform style with no scaling
  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? transition : undefined,
  };

  const baseProps: BaseMetricCardProps<T> = {
    id,
    title,
    value,
    isLoading,
    onDrilldown,
    isWip,
    tooltip,
    category,
    isDragging,
    attributes,
    listeners,
    setNodeRef, // Pass the actual ref function
    metrics,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {showBenchmark ? (
        <BenchmarkMetricCard<T>
          {...baseProps}
          benchmarkValue={benchmarkValue}
          benchmarkLoading={benchmarkLoading}
        />
      ) : (
        <MetricCard<T> {...baseProps} />
      )}
    </div>
  );
}
